import React, { useContext, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { AuthContext } from '../../contexts/AuthProvider';

const Login = () => {
    const {register,  formState: { errors }, handleSubmit} = useForm();
    const {signIn, signInWithGoogle} = useContext(AuthContext);
    const [loginError, setLoginError] = useState('');

    const location = useLocation();
    const navigate = useNavigate();
    const from = location.state?.form?.pathname || '/';


    const handleLogin = data =>{
        setLoginError('');
        console.log(data)
          signIn(data.email, data.password)
          .then(result =>{
            const user = result.user;
            console.log(user)
            toast.success('successfully login')
            navigate(from, {replace: true})
          })
          .catch(error => {
            console.log(error.message)
            setLoginError(error.message)
          })
      }


      const handleGoogle = () =>{
            signInWithGoogle()
            .then(result => {
            const user = result.user;
            console.log(user);
            toast.success('successfully login');
            navigate(from, {replace: true});
            })
            .catch(err => console.error(err))
  }


    return (
        <div className="h-[800px] flex justify-center items-cente">
      <div className="w-96 p-6">
        <form onSubmit={handleSubmit(handleLogin)}>
            <h1 className="text-4xl font-semibold text-center">Login</h1>
            {loginError && <p className="text-red-600 my-2">{loginError}</p>}
            <div className="form-control w-full max-w-xs">
                <label className="label"><span className="label-text">Email</span></label>
                <input type="email" 
                {...register("email", { required: 'Email address must be required?'})}
                className="input input-bordered w-full max-w-xs" />
                {errors.email && <p className="text-red-600">{errors.email?.message}</p>}
            </div>

            <div className="form-control w-full max-w-xs">
                <label className="label"><span className="label-text">Password</span></label>
                <input type="password" 
                {...register("password", { 
                    required: 'Password must be required?',
                    minLength: {value: 6, message: 'Password must be at least 6 characters'} 
                })} 
                className="input input-bordered w-full max-w-xs" />
                <label className="label"><span className="label-text">Forget Password</span></label>
                {errors.password && <p className="text-red-600">{errors.password?.message}</p>}
            </div>

            <input className="btn btn-accent w-full" value="Login" type="submit" />
            
        </form>
        <div>
            <p className="my-1 text-center">New to Doctors Portal <Link className="text-secondary" to='/signup'>Create a New Account?</Link> </p>
            <div className="divider">OR</div>
            <button onClick={handleGoogle} className="btn btn-outline w-full">CONTINUE WITH GOOGLE</button>
        </div>
      </div>
    </div>
    );
};

export default Login;